import Staging from './staging.config';
import Production from './production.config';
export const envConfigs = {
    production: Production,
    staging: Staging,
};
//# sourceMappingURL=config.js.map